import { render } from "./DetailTank.vue?vue&type=template&id=bdd40de4&scoped=true"
import script from "./DetailTank.vue?vue&type=script&lang=js"
export * from "./DetailTank.vue?vue&type=script&lang=js"

import "./DetailTank.vue?vue&type=style&index=0&id=bdd40de4&scoped=true&lang=css"

import exportComponent from "/var/www/ambientaly/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd40de4"]])

export default __exports__